<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <!-- basica -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtCentroEnsaque formControlName="centro_ensaque" disableCenteringOption
                                    disabled class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCentro($event.target.value)">
                                    <mat-option *ngFor="let item of listCentro" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.centro_ensaque)}}</mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Ensaque</mat-label>
                                <input matInput id="txtDataEnsaque" #txtDataEnsaque maxlength="10"
                                    formControlName="data_ensaque" mask="d0/M0/0000" type="text"
                                    (input)="validateDate($event)" [dropSpecialCharacters]="false">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error *ngIf="formulario.controls.data_ensaque.hasError('dateHighThanActual')">A
                                    data não pode ser maior que a data atual</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">N° de campo (Básica)
                                </mat-label>
                                <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="10" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    formControlName="numero_campo" (blur)="updateFields()">
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtNumeroCampo.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <mat-select #txtSafra formControlName="safra" disableOptionCentering
                                    (selectionChange)="updateFields()">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Material
                                </mat-label>
                                <input matInput id="txtMaterial" #txtMaterial maxlength="50"
                                    formControlName="hibrido_rnc" disabled class="InputBlockColor" [readonly]="true">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtMaterial.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração
                                </mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" disabled
                                    class="InputBlockColor" formControlName="geracao" [readonly]="true">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 3 -->
                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field *ngIf="!dropdownLoteds and listLoteDs.length == 0" class="w-100"
                                appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                                <input matInput id="txtLoteDs" #txtLoteDs maxlength="11" formControlName="lote_origem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtLoteDs.value.length}} / 11</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_origem)}}</mat-error>
                            </mat-form-field>
                            <mat-form-field *ngIf="dropdownLoteds and listLoteDs.length > 0" class="w-100"
                                appearance="{{ formFieldAppearance }}" floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                                <mat-select #txtLoteDs formControlName="lote_origem" disableOptionCentering>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterProcesso($event.target.value)" />
                                    <mat-option *ngFor="let item of listLoteDs" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.lote_origem) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="peneira" disableCenteringOption>
                                    <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote CS</mat-label>
                                <input matInput id="txtLoteCs" #txtLoteCs maxlength="12" formControlName="lote_saida"
                                    (blur)="setStatusLote()">
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{ txtLoteCs.value.length }} / 12</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_saida)}}
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status do Lote</mat-label>
                                <input matInput id="txtStatusDs" #txtStatusDs maxlength="100"
                                    formControlName="status_lote" disabled class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.status_lote)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 4 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de 60 Mil Sementes (kg)</mat-label>
                                <input matInput id="txtPesoMil" #txtPesoMil maxlength="5"
                                    formControlName="peso_sessenta_mil_sementes_impressao_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    (blur)="makeCalculations()">

                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPesoMil.value.length}} / 5</mat-hint>
                                <mat-error>Valor máximo de 30 kgs
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total do Lote (kg)</mat-label>
                                <input matInput id="txtPesoMil" #txtTotalKg maxlength="10"
                                    formControlName="peso_total_lote_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    (blur)="makeCalculations()">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPesoMil.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Estimativa de PA</mat-label>
                                <input matInput id="txtStatusDs" #txtEstimativaPa maxlength="10"
                                    formControlName="estimativa_pa" disabled class="InputBlockColor" readonly
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.estimativa_pa)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 5 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de Ensaque
                                </mat-label>
                                <mat-select formControlName="linha_ensaque" disableCenteringOption>
                                    <mat-option *ngFor="let item of listLinhaEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Turno de Ensaque
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="turno_ensaque" disableCenteringOption>
                                    <mat-option *ngFor="let item of listTurnoEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Ensaque</mat-label>
                                <input matInput id="txtResponsavelEnsaque" #txtResponsavelEnsaque maxlength="40"
                                    formControlName="responsavel_pelo_ensaque">
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelEnsaque.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_ensaque)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>